export default [
    {
        key: 'status',
        label: 'Status',
        variant: 'column-md'
    },
    {
        key: 'uniqueNumber',
        label: 'Shipment ID'
    },
    {
        key: 'createdAt',
        label: 'Created',
        sortable: true
    },
    {
        key: 'updatedAt',
        label: 'Updated',
        sortable: true
    },
    {
        key: 'itemsTotalCount',
        label: 'SKU',
        sortable: true
    },
    {
        key: 'itemsTotalQuantitySent',
        label: 'Total',
        sortable: true
    }
]



// WEBPACK FOOTER //
// ./src/assets/js/columns/replenishmentInventory.js